<template>
    <!-- Modal -->
    <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="staticBackdropLabel">Usuario</h1>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="cerrar()"></button>
            </div>
            <div class="modal-body">
                
                <div class="py-1 row">
                    <div class="col-md-3">
                        <label  for="name" >Nombre<span class="is-invalid">*</span> </label>
                       
                    </div>
                    <div class="col-md-9">
                        <input id="name" class="form-control" type="text" v-model="datosUsuario.name"/>
                        <label class="is-invalid">{{ validation.name }}</label>
                    </div>
                </div>
                <div class="py-1 row">
                    <div class="col-md-3">
                    

                    <label  for="apellidos" >Apellidos<span class="is-invalid">*</span></label>
                    

                    </div>
                    <div class="col-md-9">
                    <input id="apellidos" class="form-control" type="text" v-model="datosUsuario.apellidos"/>
                    <label class="is-invalid">{{ validation.apellidos }}</label>
                    </div>
                </div>
                <div class="py-1 row">
                    <div class="col-md-3">
                    

                    <label  for="email" >Email<span class="is-invalid">*</span></label>
                    
                    </div>
                    <div class="col-md-9">
                    <input id="email" class="form-control" type="text" v-model="datosUsuario.email"/>
                    <label class="is-invalid">{{validation.email}}</label>
                    </div>
                </div>
                <div class="py-1 row">
                    <div class="col-md-3">
                    

                    <label  for="email" >Contraseña<span class="is-invalid">*</span></label>
                    
                    </div>
                    <div class="col-md-9">
                    <input id="email" class="form-control" type="password" v-model="datosUsuario.password"/>
                    <label class="is-invalid">{{validation.password}}</label>
                    </div>
                </div>
                <div class="py-1 row">
                    <div class="col-md-3">
                        <label  for="telefono" >Telefono <span class="is-invalid">*</span></label>
                      
                    </div>
                    <div class="col-md-9">
                    <input id="email" class="form-control" type="text" v-model="datosUsuario.telefono"/>
                    <label class="is-invalid">{{validation.telefono}}</label>
                    </div>
                </div>
                <div class="py-1 row">
                    <div class="col-md-3">
                        <label  for="telefono" >Tipo <span class="is-invalid">*</span></label>
                      
                    </div>
                    <div class="col-md-9">
                        <select class="form-control" v-model="datosUsuario.role_id" @change="mostrarDocumentos">
                            <option v-for="roles in datosroles" :value="roles.name">{{ roles.name}}</option>
                        </select>
                    
                    <label class="is-invalid">{{validation.role_id}}</label>
                    </div>
                </div>
                <div class="py-1 row">
                    <div class="col-md-3">
                        <label  for="telefono" >Direccion <span class="is-invalid">*</span></label>
                      
                    </div>
                    <div class="col-md-9">
                    <input id="email" class="form-control" type="text" v-model="datosUsuario.direccion"/>
                    <label class="is-invalid">{{validation.direccion}}</label>
                    </div>
                </div>
                <div class="col-md-12 row" >
                    <div class="col-md-3" style="display: none;" id="documentos">
                        <label  for="telefono" >Documentos</label>
                      
                    </div>
                    <div class="col-md-9" style="display: none;" id="documentosArchivo">
                        <input type="file" multiple @change="handleFileUpload" class="form-control"/> 
                    </div>
                  <!--<div class="col-md-4">
                  <button @click="uploadFiles" class="btn btn-success">Guardar Imagenes</button>
                </div>-->
                </div>
                <br>
                  <div  v-if="images.length > 0" class="col-md-12 image-gallery">
                    <div v-for="(image, index) in images" :key="index" class="image-item">
                        <a :href="this.$rutaImagenes + image.preview" 
                        :download="getImageName(image.preview)" 
                        class="download-link">
                         <img :src="image.preview" :alt="'Image ' + (index + 1)" class="preview-image" width="600px" />
                     </a>
                        <button @click="removeImage(index,image.id)" class="remove-button">Eliminar</button>
                        <br>
                        <!-- Botón para descargar la imagen -->
                        <a :href="image.preview" :download="'image_' + (index + 1) + '.jpg'" target="_blank">
                            <button class="btn btn-warning">Descargar</button>
                        </a>
                    </div>
                  </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" ref="botonObjetivo" @click="cerrar()">Cancelar</button>
              <button v-if="modalAlta == false" type="button" class="btn" style="background-color: #F49315; color: white;" @click="actualizaUsuario">Actualizar</button>
              <button v-else type="button" class="btn" style="background-color: #F49315; color: white;" @click="altaUsuario">Guardar</button>
            </div>
          </div>
        </div>
      </div>
    
        <div class="col-md-12">
            <div class="">
                <h4 class="mb-sm-0">Usuarios</h4>
                <br>
                

            </div>
            <div class="py-1 row">
                <div class="col-md-1">
                    <button type="button" class="btn" style="background-color: #F49315; color: white;" data-bs-toggle="modal" data-bs-target="#staticBackdrop" @click="registrarUsuario">Registrar</button>
                </div>
            </div>
        </div>
        
    
  
        <!--<div class="col-md-6">
            <span>Buscar Columna:</span>
            <select class="form-control" v-model="searchField">
                <option value="name">Nombre</option>
                <option value="apellidos">Apellidos</option>
            </select>
    
            <br/>

            <span>Buscar: </span>
            <input type="text" class="form-control" v-model="searchValue">
        </div>-->
        <div class="row align-items-end">
            <div class="col-md-4">
                <label class="form-label">Buscar Columna:</label>
                <select class="form-control" v-model="searchField">
                    <option value="name">Nombre</option>
                    <option value="apellidos">Apellidos</option>
                </select>
            </div>

            <div class="col-md-4">
                <label class="form-label">Buscar:</label>
                <input
                    type="text"
                    class="form-control"
                    v-model="searchValue"
                >
            </div>
        </div>
        <br>
        <EasyDataTable
          :headers="headers"
          :items="users"
          :search-field="searchField"
            :search-value="searchValue"
        >
        <template #item-operation="item">
            <div class="operation-wrapper">
              <!--<img
                src="./images/delete.png"
                class="operation-icon"
                @click="deleteItem(item)"
              />-->
              <!--<img
                src="./images/edit.png"
                class="operation-icon"
                @click="editItem(item)"
              />-->
              
              <button class="fa fa-eye btn-success" type="button" data-bs-toggle="modal" data-bs-target="#staticBackdrop" @click="showRow(item)"></button> &nbsp;
              <button class="fa fa-trash btn-danger" type="button" data-bs-toggle="modal" data-bs-target="#staticBackdrop"></button>
              
            </div>
          </template>
          </EasyDataTable>
     
</template>
<script>
//import type { Header, Item } from "vue3-easy-data-table";
import "vue3-easy-data-table/dist/style.css";
var dominio = window.location.host.split(':');
var url = 'https://backsarei.seguridadeninspeccion.com/api';
//var url = 'http://127.0.0.1:8000/api';

import axios from 'axios';
import Swal from 'sweetalert2';
export default {
    data() {
        return {
            searchField:[],
            searchValue:[],
            users:[],
            headers:[],
            datosUsuario:{
                id:'',
                name:'',
                apellidos:'',
                direccion:'',
                telefono: '',
                email:'',
                role_id:'',
                password:''
            },
            validation:{
                name:'',
                apellidos:'',
                direccion:'',
                telefono: '',
                email:'',
                role_id:'',
                password:''
            },
            datosroles:[],
            modalAlta: false,
            images:[],
            file:'',
            preview:''
        }
    },
    created() {
        this.consultarUsuarios();
        this.consultarRoles();
    },
    methods: {
        getImageName(url) {
    // Extrae el nombre del archivo de la URL
    return url.split('/').pop();
  },
        mostrarDocumentos(){
            if(this.datosUsuario.role_id == 'Inspector'){
                document.getElementById('documentos').style.display = 'block';
                document.getElementById('documentosArchivo').style.display = 'block';

            }
        },
        removeImage(index,id){
            this.images.splice(index, 1);
            axios.post(url+'/eliminarImagenInspector',{id:id})
                .then(response => {
                    if(response.status == 200){
                    //this.users = response.data.data;
                    Swal.fire('¡Éxito!', 'Imagen eliminada', 'success');
                   
                    
                    }
                })
                .catch(error => {
                   
            });
        },
        handleFileUpload(event){
        const files = event.target.files;
        if (files) {
            var objetu = '';
            const newImages = Array.from(files).map(file => {
                    /*objeto = {
                    file:file,
                    preview = URL.createObjectURL(file)
                    }*/
                    return {
                        file,
                        preview: URL.createObjectURL(file)
                    };
            });
         
          this.images.push(...newImages);
        }
      },
        altaUsuario(){
            //alert(this.datosUsuario.role_id);
            const formData = new FormData();
            this.images.forEach(image => {
                formData.append('images[]', image.file); // Nota el cambio en el nombre del campo
            });
            formData.append('name', this.datosUsuario.name); 
            formData.append('apellidos', this.datosUsuario.apellidos); 
            formData.append('email', this.datosUsuario.email); 
            formData.append('telefono', '2558964785'); //this.datosUsuario.telefono 
            formData.append('direccion', this.datosUsuario.direccion); 
            formData.append('role', this.datosUsuario.role_id); 
            formData.append('password', this.datosUsuario.password); 

            const token = localStorage.getItem('accessToken');
            const config = {
                headers: {
                Authorization: `Bearer ${token}`,
                Accept:'application/json'
                }
            };
            /*{
                name:this.datosUsuario.name,
                apellidos:this.datosUsuario.apellidos,
                email:this.datosUsuario.email,
                telefono:this.datosUsuario.telefono,
                direccion:this.datosUsuario.direccion,
                role:this.datosUsuario.role_id,
                password:this.datosUsuario.password,
                

            }*/
            axios.post(url+'/registerUser',formData,config)
                .then(response => {
                    if(response.status == 200){
                    //this.users = response.data.data;
                    Swal.fire('¡Éxito!', 'Usuario registrado', 'success');
                    this.consultarUsuarios();
                    this.$refs.botonObjetivo.click();
                    this.cerrar();
                    
                    }
                })
                .catch(error => {
                    //console.log(error.response.data.errors);
                    if(error.response.data.errors?.password?.[0]){
                      this.validation.password = 'el campo password no debe ser vacio.';
                    }
                    if(error.response.data.errors?.email?.[0]){
                      this.validation.email = 'el campo email no debe ser vacio.';
                    }
                    if(error.response.data.errors?.name?.[0]){
                      this.validation.name = 'El nombre no debe ser vacio.';
                    }
                    if(error.response.data.errors?.apellidos?.[0]){
                      this.validation.apellidos = 'El apellido no debe ser vacio.';
                    }
                    if(error.response.data.errors?.telefono?.[0]){
                      this.validation.telefono = 'El telefono no debe ser vacio.';
                    }
                    if(error.response.data.errors?.direccion?.[0]){
                      this.validation.direccion = 'La dirección no debe ser vacio.';
                    }
                    //Swal.fire('¡Error!', 'Ocurrio un error ','error');
            });
        },
        registrarUsuario(){
            this.modalAlta = true;
        },
        async downloadImage(imageUrl) {
    try {
      // Realiza la solicitud para obtener la imagen como un blob
      const response = await axios.get(imageUrl, { responseType: 'blob' });

      // Crea una URL de objeto con los datos de la imagen
      const url = window.URL.createObjectURL(new Blob([response.data]));
      
      // Extrae el nombre de la imagen de la URL
      const imageName = imageUrl.split('/').pop();

      // Crea un enlace temporal para la descarga
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', imageName); // Asigna el nombre deseado para la imagen
      document.body.appendChild(link);
      link.click();
      
      // Limpia el DOM
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url); // Limpia la URL del objeto
    } catch (error) {
      console.error('Error al descargar la imagen:', error);
    }
  },
        cerrar(){
            this.validation.name = '';
            this.validation.apellidos = '';
            this.validation.direccion = '';
            this.validation.telefono = '';
            this.validation.email = '';
            this.validation.role_id = '';
            this.validation.password = '';
            this.datosUsuario.name = '';
            this.datosUsuario.apellidos = '';
            this.datosUsuario.direccion = '';
            this.datosUsuario.email = '';
            this.datosUsuario.role_id = '';
            this.datosUsuario.telefono = '';
            this.datosUsuario.password ='';
            this.images = [];
            document.getElementById('documentos').style.display = 'none';
            document.getElementById('documentosArchivo').style.display = 'none';


        },
        showRow(item){
            this.modalAlta = false;
            if(this.modalAlta == true){

            }
            else{
                
                this.datosUsuario.name = item.name;
                this.datosUsuario.apellidos = item.apellidos;
                this.datosUsuario.direccion = item.direccion;
                this.datosUsuario.telefono = item.telefono;
                this.datosUsuario.email = item.email;
                //this.datosUsuario.role_id = item.role_id;
                this.datosUsuario.role_id = item.role;
                if(item.role_id == 2){
                    this.mostrarDocumentos();
                }
                axios.post(url+'/consultarImagenesInspector',{idusuario:item.id})
                .then(response => {
                    if(response.status == 200){
                        //this.images = response.data.imagenes;
                        response.data.imagenes.forEach(ele => {
                            var obj = {
                                id:ele.id,
                                preview:this.$rutaImagenes+ele.url_imagen
                            }
                            this.images.push(obj);
                        });
                        console.log(this.images);
                    }
                })
                .catch(error => {
                    Swal.fire('¡Error!', 'Ocurrio un error ','error');
                });
            }
           
        },
        consultarUsuarios(){
            //console.log(localStorage.getItem('accessToken'+'aqui'));
            const token = localStorage.getItem('accessToken');
            const config = {
                headers: {
                Authorization: `Bearer ${token}`,
                Accept:'application/json'
                }
            };
            axios.get(url+'/users',config)
                .then(response => {
                    if(response.status == 200){
                    this.users = response.data.data;
                    
                    this.headers = [
                        { text: "Nombre", value: "name", sortable: true },
                        { text: "Apellidos", value: "apellidos", sortable: true },
                        { text: "Email", value: "email", sortable: true},
                        { text: "Tipo", value: "role", sortable: true}, 
                        { text: "Operation", value: "operation", sortable: true},
                    ];
                    this.searchField  = ['name'];
                    //this.searchValue = this.users;

                    }
                })
                .catch(error => {
                Swal.fire('¡Error!', 'Ocurrio un error ','error');
                });
        },
        consultarRoles(){
            //console.log(localStorage.getItem('accessToken'+'aqui'));
            const token = localStorage.getItem('accessToken');
            const config = {
                headers: {
                Authorization: `Bearer ${token}`,
                Accept:'application/json'
                }
            };
            axios.get(url+'/roles',config)
                .then(response => {
                    if(response.status == 200){
                        this.datosroles = response.data.data;
                    }
                })
                .catch(error => {
                Swal.fire('¡Error!', 'Ocurrio un error ','error');
                });
        },
        actualizaUsuario(){
            console.log(this.datosUsuario);
            const token = localStorage.getItem('accessToken');
            const config = {
                headers: {
                Authorization: `Bearer ${token}`,
                Accept: 'application/json'
                }
            };

            const formData = new FormData();
            this.images.forEach(image => {
                formData.append('images[]', image.file); // Nota el cambio en el nombre del campo
            });
            formData.append('id', this.datosUsuario.id);
            formData.append('name', this.datosUsuario.name); 
            formData.append('apellidos', this.datosUsuario.apellidos); 
            formData.append('email', this.datosUsuario.email); 
            formData.append('telefono', this.datosUsuario.telefono ); //this.datosUsuario.telefono 
            formData.append('direccion', this.datosUsuario.direccion); 
            formData.append('role', this.datosUsuario.role_id); 
            formData.append('password', this.datosUsuario.password); 

            axios.post(url + '/actualizarUsuario',
                /*id:this.datosUsuario.id,
                name:this.datosUsuario.name,
                apellidos:this.datosUsuario.apellidos,
                email:this.datosUsuario.email,
                telefono:this.datosUsuario.telefono,
                direccion:this.datosUsuario.direccion,
                password:this.datosUsuario.password,
                role:this.datosUsuario.role_id*/
                formData
            ,config)
                .then(response => {
                if (response.status == 200) {
                    
                    if (response.data) {
                        Swal.fire('¡Éxito!', 'Usuario Actualizado', 'success');
                        this.consultarUsuarios();
                        this.$refs.botonObjetivo.click();
                    }
            
                }
                })
                .catch(error => {
                    
                    if(error.response.data.errors?.password?.[0]){
                      this.validation.password = 'el campo password no debe ser vacio.';
                    }
                    if(error.response.data.errors?.email?.[0]){
                      this.validation.email = 'el campo email no debe ser vacio.';
                    }
                    if(error.response.data.errors?.name?.[0]){
                      this.validation.name = 'El nombre no debe ser vacio.';
                    }
                    if(error.response.data.errors?.apellidos?.[0]){
                      this.validation.apellidos = 'El apellido no debe ser vacio.';
                    }
                    if(error.response.data.errors?.telefono?.[0]){
                      this.validation.telefono = 'El telefono no debe ser vacio.';
                    }
                    if(error.response.data.errors?.direccion?.[0]){
                      this.validation.direccion = 'La dirección no debe ser vacio.';
                    }
                });
        }
    },  
    components: { 
      EasyDataTable: window["vue3-easy-data-table"]
    },
}
</script>
<style>
    .is-invalid {
        color: red;
    }
    .image-gallery {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
      }
      
      .image-item {
        position: relative;
        display: inline-block;
      }
      
      .preview-image {
        max-width: 150px;
        max-height: 150px;
        object-fit: cover;
        border: 1px solid #ddd;
        border-radius: 4px;
      }
      
      .remove-button {
        position: absolute;
        top: 5px;
        right: 5px;
        background: red;
        color: white;
        border: none;
        border-radius: 50%;
        cursor: pointer;
      }
</style>